import React from "react";

interface ProgressBarProps {
  percent: number;
  message: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ percent, message }) => {
  return (
    <div className="w-full">
      <div className="mb-2 flex justify-between items-center">
        <span className="text-sm text-text-primary">{message}</span>
        <span className="text-sm font-semibold text-rose-accent">{percent}%</span>
      </div>
      <div className="w-full bg-navy-mid rounded-sm h-3 shadow-inner relative">
        <div
          className="absolute top-0 left-0 h-full rounded-sm transition-all duration-300 ease-out overflow-hidden"
          style={{
            width: `${percent}%`,
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-navy-lighter to-rose-accent">
            <div
              className="h-full w-full bg-gradient-to-r from-transparent via-white to-transparent opacity-20 animate-shimmer"
              style={{
                filter: "blur(0px)",
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
